/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const funcName = "wba";
const MAX_TITLE_LENGTH = 500;
const userIdCookieName = "_wbauid";
const EVENT_ID_KEY = "_wbaeid";

const RETRY_STATUSES = [408, 500];

var urlProduction = "https://a.wb.ru/e";
var urlStage = "https://stage-wba-nginx.wb.ru/e";
var urlDevelopment = "https://dev-wba-nginx.wb.ru/e";
var retryConfig = {
	countLimit: 5
};
var config = {
	urlProduction: urlProduction,
	urlStage: urlStage,
	urlDevelopment: urlDevelopment,
	retryConfig: retryConfig
};

/* eslint-disable @typescript-eslint/dot-notation, class-methods-use-this */
const metricEndpoint = "{{ nginx_sdk_js_host }}";
const sdkVersionBuildNumber = "1.0.2";
const setClientIdEventName = "user_id";
const goalReachEventName = "goal_reach";
const ecEventName = "ec";
const initEventName = "init";
// const pageViewEventName = "pageview"
const ecSendCmdName = "ec:send";
const ecAddProductCmdName = "ec:addProduct";
const ecSetActionCmdName = "ec:setAction";
const ecSetCurrencyCmdName = "ec:setCurrency";
const ecClear = "ec:clear";
class SDK {
    constructor() {
        this._ecCurrency = "";
        this._ecProductItems = null;
        this._debugMode = false;
        this.isSsr = typeof window === "undefined";
    }
    init() {
        if (this.isSsr || !window[funcName]) {
            return;
        }
        this.initTime = window[funcName].l;
        window["wba-url"] = metricEndpoint;
        const queue = window[funcName].q;
        if (Array.isArray(queue)) {
            queue.forEach(e => {
                this.HandleCmd(e[0], e[1]);
            });
        }
        window[funcName] = this.HandleCmd.bind(this);
    }
    initUserId(reset) {
        let cuid = this.getUserID();
        if (cuid === "" || reset) {
            cuid = this.genNewUserID();
            this.isNewUser = true;
        }
        this.userId = cuid;
    }
    getUserID() {
        return (document.cookie
            .split(";")
            .map(value => value.trim())
            .filter(value => {
            return value.substring(0, userIdCookieName.length + 1) === `${userIdCookieName}=`;
        })
            .map(value => {
            return value.substring(userIdCookieName.length + 1);
        })[0] || "");
    }
    HandleCmd(cmd, options) {
        if (options == null) {
            options = {};
        }
        try {
            switch (cmd) {
                case initEventName:
                    this.HandleInitCmd(options);
                    break;
                case setClientIdEventName:
                    this.HandleSetClientIdCmd(options);
                    break;
                case goalReachEventName:
                    this.HandleGoalReachCmd(options);
                    break;
                case ecSendCmdName:
                    this.ECHandleSendCmd(options);
                    break;
                case ecAddProductCmdName:
                    this.ECHandleAddProductCmd(options);
                    break;
                case ecSetCurrencyCmdName:
                    this.ECHandleSetCurrencyCmd(options);
                    break;
                case ecSetActionCmdName:
                    this.ECHandleSetActionCmd(options);
                    break;
                case ecClear:
                    this.ECClear();
                    break;
                default:
                    this.HandleSimpleEvent(cmd, options);
                    break;
            }
        }
        catch (e) {
            try {
                if (this.isDebugMode()) {
                    console.error(`An error occurred while handling '${cmd}' command:\n\t${e}`);
                }
            }
            catch (_a) { }
        }
    }
    genNewUserID() {
        const ts = Math.floor(new Date().getTime() / 1000);
        const id = Math.floor(Math.random() * Math.pow(2, 30));
        const newId = id.toString() + ts.toString();
        const date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        document.cookie = `${userIdCookieName}=${newId}; expires=${date.toUTCString()}; path=/; domain=${this._cookieDomain}`; // prettier-ignore
        return newId;
    }
    HandleSimpleEvent(name, options) {
        this.SendEvent(name, this.BuildStatParams(), { cp: options });
    }
    ECClear() {
        this._ecAction = null;
        this._ecProductItems = null;
    }
    ECPrepareJSON() {
        const data = {};
        if (this._ecAction == null) {
            data.action = {
                type: "unspecified",
                currency: this._ecCurrency,
            };
        }
        else {
            data.action = this._ecAction;
        }
        if (this._ecProductItems != null) {
            data.products = this._ecProductItems;
        }
        return data;
    }
    ECHandleAddProductCmd(product) {
        if (this._ecProductItems == null) {
            this._ecProductItems = [];
        }
        if (product.inListIndex == null && product.position != null) {
            product.inListIndex = product.position;
            delete product.position;
        }
        if (product.list != null) {
            if (product.listID == null) {
                product.listID = product.list;
            }
            if (product.listName == null) {
                product.listName = product.list;
            }
            delete product.list;
        }
        this._ecProductItems.push(product);
    }
    ECHandleSendCmd(params) {
        const bodyParams = this.ECPrepareJSON();
        bodyParams.cp = params;
        this.ECClear();
        this.SendEvent(ecEventName, this.BuildStatParams(), bodyParams);
    }
    ECHandleSetCurrencyCmd(currency) {
        this._ecCurrency = currency;
        if (this._ecAction != null) {
            this._ecAction.currency = currency;
        }
    }
    ECHandleSetActionCmd(opts) {
        if (typeof opts === "object") {
            this._ecAction = opts;
        }
        else {
            if (this._ecAction == null) {
                this._ecAction = {};
            }
            this._ecAction.type = opts;
        }
        this._ecAction.currency = this._ecCurrency;
    }
    HandleSetClientIdCmd(options) {
        const { clientId } = options, rest = __rest(options, ["clientId"]);
        this.clientId = clientId;
        this.SendEvent(setClientIdEventName, this.BuildStatParams(), { cp: rest });
    }
    HandleInitCmd(options) {
        this.counterId = options.counterId;
        this.clientId = options.clientId;
        this._debugMode = options.debugMode === true;
        const domain = options.cookieDomain;
        if (typeof domain === "string" && domain.length !== 0) {
            this._cookieDomain = domain;
        }
        else if (!this.isSsr) {
            this._cookieDomain = window.location.hostname;
        }
        const resetFlag = options.resetUserId;
        this.initUserId(typeof resetFlag === "boolean" ? resetFlag : false);
        if (this._debugMode) {
            try {
                console.log(`Initialization done:\n\tthis.counterId='${this.counterId}'\n\tthis.userId='${this.userId}'\n\tthis.clientId='${this.clientId}'\n\tthis._debugMode='${this._debugMode}'\n\tthis._cookieDomain='${this._cookieDomain}'\n\tSDKVersionBuildNum='${sdkVersionBuildNumber}'`);
            }
            catch (_a) { }
        }
    }
    HandleGoalReachCmd(options) {
        const { name, price100, currency } = options, rest = __rest(options, ["name", "price100", "currency"]);
        const params = this.BuildStatParams();
        params.gn = name;
        params.gp100 = price100;
        params.gcr = currency;
        this.SendEvent(goalReachEventName, params, { cp: rest });
    }
    BuildStatParams() {
        const o = {};
        o.t = document.title.substring(0, MAX_TITLE_LENGTH);
        o.u = document.URL;
        o.cid = this.counterId;
        o.s = this.GetScreenInfo();
        o.w = this.GetWindowInfo();
        o.user_id = this.userId;
        o.vbn = sdkVersionBuildNumber;
        o.event_num = this.getEventId();
        // const fingerprint = window.localStorage.getItem(fingerprintStorageKey)
        // if (fingerprint) {
        //   o.fp = fingerprint
        // }
        const event = new Date();
        o.timestamp = event.toISOString();
        o.timezone_offset = -event.getTimezoneOffset();
        o.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (this.clientId) {
            o.client_id = this.clientId;
        }
        const ref = document.referrer.trim();
        if (ref.length > 0) {
            o.r = ref;
        }
        if (this.isNewUser) {
            o.nu = 1;
        }
        return o;
    }
    GetScreenInfo() {
        if (this.isSsr) {
            return "";
        }
        const width = window.screen.width * (window.devicePixelRatio || 1);
        const height = window.screen.height * (window.devicePixelRatio || 1);
        const depth = window.screen.colorDepth;
        return `${width | 0}x${height | 0}x${depth | 0}`; // eslint-disable-line no-bitwise
    }
    GetWindowInfo() {
        if (this.isSsr) {
            return "";
        }
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        return `${width | 0}x${height | 0}`; // eslint-disable-line no-bitwise
    }
    getEventId() {
        let eventId = 1;
        if (!this.isSsr && window.localStorage) {
            eventId = (Number(window.localStorage.getItem(EVENT_ID_KEY)) || 0) + 1;
            window.localStorage.setItem(EVENT_ID_KEY, String(eventId));
        }
        return eventId;
    }
    getHostUrl() {
        if (!this.isSsr && typeof window["wba-url"] === "string" && window["wba-url"].startsWith("http")) {
            return window["wba-url"];
        }
        if (process.env.NODE_ENV === "dev" || process.env.NODE_ENV === "development")
            return config.urlDevelopment;
        if (process.env.NODE_ENV === "stage" || process.env.NODE_ENV === "staging")
            return config.urlStage;
        if (process.env.NODE_ENV === "prod" || process.env.NODE_ENV === "production")
            return config.urlProduction;
        return "";
    }
    SendEvent(eventName, getParams, bodyParams = {}) {
        const qsi = [];
        Object.keys(getParams).forEach(key => {
            const val = getParams[key];
            if (val == null)
                return;
            qsi.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        });
        const qs = qsi.join("&");
        const host = this.getHostUrl();
        const url = `${host}/${encodeURIComponent(eventName)}?${qs}`;
        const body = JSON.stringify(bodyParams);
        this.sendData(url, body);
    }
    sendAsXHR(url, body) {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader("Content-Type", "text/plain");
        xhr.send(body);
    }
    sendAsBeacon(url, body) {
        const blobData = new window.Blob([body], { type: "text/plain" });
        try {
            if (window.navigator.sendBeacon(url, blobData)) {
                return;
            }
        }
        catch (e) { }
        //Fallback to xhr
        this.sendAsXHR(url, body);
    }
    sendData(url, body) {
        var _a;
        if (!this.isSsr && typeof ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.sendBeacon) === "function" && typeof window.Blob === "function") {
            this.sendAsBeacon(url, body);
        }
        else {
            this.sendAsXHR(url, body);
        }
    }
    sendAsFetch(url, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const { countLimit } = config.retryConfig;
            for (let i = 0; i < countLimit; i++) {
                try {
                    const response = yield fetch(url, {
                        method: "POST",
                        headers: { "Content-Type": "text/plain" },
                        body,
                    });
                    if (!RETRY_STATUSES.includes(response.status)) {
                        return;
                    }
                }
                catch (_a) { }
            }
        });
    }
    isDebugMode() {
        if (this._debugMode) {
            return true;
        }
        else {
            try {
                return window.location.href.indexOf("_adebug=1") >= 0;
            }
            catch (e) {
                return false;
            }
        }
    }
}

const metrics = new SDK();
metrics.init();

export { metrics };
